import { backendId, BaseBackendInterface } from './types';

abstract class BaseBackend<T = Record<string, unknown>> implements BaseBackendInterface<T> {
  id: backendId;
  baseUrl: string;
  config?: T;

  constructor(attrs: Partial<BaseBackend>) {
    Object.assign(this, attrs);
  }
}

/**
 * @internal
 */
export class Backend extends BaseBackend {}

// Contract
class ContractBackendConfig {
  token: string;

  constructor(attrs: Partial<ContractBackendConfig>) {
    Object.assign(this, attrs);
  }
}

/**
 * @internal
 */
export class ContractBackend extends BaseBackend<ContractBackendConfig> {
  constructor(attrs: Partial<BaseBackend>) {
    super(attrs);
    this.config = new ContractBackendConfig(attrs.config);
  }
}
